import { render } from "./QAQCPagination.vue?vue&type=template&id=7d0d7ea8"
import script from "./QAQCPagination.vue?vue&type=script&lang=js"
export * from "./QAQCPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__